import React from 'react';
import { CommonDeleteModal } from 'components';
import { useDeleteModal } from './useDeleteModal';

interface DeleteModal {
  openModal: boolean;
  recordId: string | undefined;
  onDeleteModalClose: (id?: string) => void;
}

export const DeleteModal = (props: DeleteModal) => {
  const { openModal, onDeleteModalClose, recordId } = props;
  const { onRemoveConfirm, isLoading } = useDeleteModal(onDeleteModalClose);
  return (
    <CommonDeleteModal
      onCancel={() => onDeleteModalClose()}
      open={openModal}
      isLoading={isLoading}
      onOk={() => onRemoveConfirm(recordId)}
      onClose={() => onDeleteModalClose()}
      title={'Remove Supplier Offer'}
      message={'Are you sure you want to remove this supplier offer?'}
    />
  );
};
